<template>
  <BaseAlert class="py-4 mt-2 mt-md-3 mb-8" :always-show="true" type="warning" icon="info" outlined>
    <template #additionalMessageRow>
      <div class="my-n4">
        <span class="mr-3">{{ $t('hubspot.alertToMyData') }}</span>
        <MyDataButton
          class="d-inline-block my-2"
          :compare-data="compareData"
          @input="$emit('input', $event)"
        />
      </div>
    </template>
  </BaseAlert>
</template>

<script>
import MyDataButton from '@/js/components/Usermanagement/MyDataButton.vue'
export default {
  name: 'MyDataInfobox',
  components: {
    MyDataButton,
  },
  props: {
    compareData: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss" module></style>
